export default __webpack_public_path__ + "static/media/ellips-1.60e04de2.svg";